import { render, staticRenderFns } from "./SortableButton.vue?vue&type=template&id=86f20a22&scoped=true&"
import script from "./SortableButton.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./SortableButton.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./SortableButton.vue?vue&type=style&index=0&id=86f20a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f20a22",
  null
  
)

export default component.exports